import { AxiosRequestConfig, AxiosResponse } from 'axios';

import AbstractCRMApi from '../../../AbstractCRMApi';
import GetLootboxTicketResponse from '../../Responses/Lootbox/UserLootboxResponse';
import GetPaginatedResponse from '../../Responses/PaginatedResponse';

class UserLootboxApi extends AbstractCRMApi {
    public endpoint: string = 'user_lootbox';

    public getAll(
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<GetLootboxTicketResponse>> {
        return this.get('', {
            ...config,
            params: { ...config?.params, page },
        }).then((response: AxiosResponse<GetPaginatedResponse<GetLootboxTicketResponse>>) => {
            return response.data;
        });
    }

    public getById(id: number): Promise<GetLootboxTicketResponse> {
        return this.get(`/${id}`).then((response: AxiosResponse) => response.data);
    }
}

export default new UserLootboxApi();
